module.exports = __webpack_public_path__ + "img/coupon_tutorial_gimmi03.092ccfa1.png";